module.exports = __webpack_public_path__ + "static/media/hex-viewer.e707ddac.png";